'use strict';

let App = {
	Pages: {},
	Modules: {},
	Models: {},
};

export {App};
